import React from "react";

import { GenericBannerAlert } from "@src/components/MainApp/Alerts/GenericBannerAlert";
import { SubscriptionInfoAlert } from "@src/components/MainApp/Alerts/SubscriptionInfoAlert";
import { SystemStatus } from "@src/components/MainApp/Alerts/SystemStatus";

import { FreeTrialStatusAlert } from "../components/MainApp/Alerts/FreeTrialStatusAlert";
import { Processes } from "../components/MainApp/Alerts/Processes";
import { ScriptStatusAlert } from "../components/MainApp/Alerts/ScriptStatusAlert";

export const AlertProvider = () => {
  // unhide hideLights and add style tag to div for xmas lights
  // const hideLights = useMemo(() => Cookies.get("hideLights"), []);
  // style={{ marginTop: hideLights ? undefined : "60px" }

  return (
    <div>
      {/*<SystemStatus />*/}
      {/*<GenericBannerAlert />*/}
      {/*<ExperimentInterfaceAlert />*/}
      {/*<SubscriptionInfoAlert />*/}
      <ScriptStatusAlert />
      <Processes />
    </div>
  );
};
